import request from '@/utils/sap-request'

// 积分申请
export const apiApplyIntegral = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/reverse_int',
    method: 'POST',
    data
  })
}

// 积分申请查询
export const getReverseIntegralList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_reverse_int',
    method: 'POST',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/sap/integral-sap.js